import React, { PureComponent } from "react";
import { noop } from "lodash";

import ListItem from "../../_molecule/ListItem";

import ListItemsWrapper, {
  ListItemsTitle,
  ListItemsDescription
} from "./styled-components";

export default class ListItems extends PureComponent {
  static defaultProps = {
    title: "",
    description: null,
    listItems: [],
    buttonClickHandler: noop
  };

  renderList = (listItems, buttonClickHandler) =>
    listItems.map((item) => (
      <ListItem
        item={{
          ...item,
          promptClick: () => buttonClickHandler(item.title, item.url)
        }}
        key={`listItems_${item.id}`}
      />
    ));

  render = () => {
    const { title, description, listItems, buttonClickHandler } = this.props;
    return (
      <ListItemsWrapper data-qa-label={`${title.replace(/ /g, "")}_ListItems`}>
        <ListItemsTitle data-qa-label={title.replace(/ /g, "")}>
          {title}
        </ListItemsTitle>
        {description && (
          <ListItemsDescription
            data-qa-label={`${title.replace(/ /g, "")}_Description`}
          >
            {description}
          </ListItemsDescription>
        )}

        {this.renderList(listItems, buttonClickHandler)}
      </ListItemsWrapper>
    );
  };
}
